/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
export const PIPELINE_INPUT_TIMEOUT = 3000;
export const PIPELINE_ACTION_TIMEOUT = 6000;